import React from "react";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "./SignInButton";
import {
	Container,
	Button,
	Grid,
	Paper,
	TextField,
	IconButton,
	InputAdornment,
	CssBaseline,
	Typography,
  } from "@mui/material";
  import VisibilityIcon from "@mui/icons-material/Visibility";
  import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
  import { useState, useEffect, useRef } from "react";
  //import useAuth from "../../hooks/useAuth";
  //import logo from "../../assets/images/quanti-logo-white.png";
  import logo from "../../../assets/images/sims.png";
  import { useNavigate } from "react-router-dom";
  import { useDispatch } from "react-redux";
  //import { setState, login, forgotPassword } from "../../store/loginSlice";
  //import { setState } from "../Admin/centralAdminSlice";

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = (props) => {
	const isAuthenticated = useIsAuthenticated();

	return (
		// <>
		// 	<Typography>{props.children}</Typography>

			
		// 		<a className="navbar-brand" href="/">
		// 			Microsoft Identity Platform
		// 		</a>
		// 		<Box>
		// 			{isAuthenticated ? <SignOutButton /> : <SignInButton />}
		// 		</Box>
			
		// </>

		<div>
      <Container maxWidth="xs" sx={{
        minHeight:'calc(100vh - 50px)',
        display:'flex',
        alignItems:'center',
        justifyContent:'center'
      }}>
        <Grid
          container
          spacing={4}
          direction="column"
          justifyContent="center"
          style={{ minHeight: "70vh", borderRadius: "10px" }}
        >
          <Paper elelvation={2} sx={{ padding: 5, borderRadius: 2 }}>
		  <Grid
                  item
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
					flexDirection: "column"
                  }}
                >
		  	<img style={{display:'block', marginBottom:"40px"}} height="50px" src={logo} alt="SIMS" /> 
			<SignInButton />
			</Grid>
            <section>
              <Typography
                //ref={errRef}
                style={{
                  color: "red",
                  textAlign: "center",
                }}
                aria-live="assertve"
              >
                {""}
              </Typography>
            </section>
          </Paper>
        </Grid>
      </Container>
      <br />
    </div>
	);
};
